import React, { CSSProperties, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';
import UserDropDown from 'components/Header/components/UserDropDown/UserDropDown';
import logoWhite from 'assets/logo-white.svg';
import minimizeIcon from 'assets/icons/minimize-drawer.svg';
import logoShort from 'assets/logo-short.svg';

import NavigationItem from './NavigationItem';

import './NavigationDrawer.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  onLayoutChange: (val: boolean) => void;
  isMinimized: boolean;
  tooltipElement?: React.ReactNode;
}

const NavigationDrawer: React.FC<Props> = ({ style, isMinimized, onLayoutChange }) => {
  const user = useAppSelector(getUser);
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  const { t } = useTranslation();
  const history = useHistory();

  const parentTabs = [
    {
      icon: 'dash',
      name: t('common:Navigation_Drawer.Dash/Today'),
      path: '/',
    },
    {
      icon: 'grades',
      name: t('common:Navigation_Drawer.Grades'),
      path: '/grades',
      code: 'grading',
    },
    {
      icon: 'chat',
      name: t('common:Navigation_Drawer.Chat'),
      path: '/chat',
      code: 'chat',
    },
    {
      icon: 'book',
      name: t('common:Navigation_Drawer.Study'),
      path: '/study',
      code: 'study',
    },
  ];

  // const teacherTabs = [
  // {
  //   icon: 'admin',
  //   name: t('common:Navigation_Drawer.Admin'),
  //   path: '/admin',
  //   code: 'admin',
  //   subMenus: [
  //     {
  //       name: t('common:Navigation_Drawer.User Management'),
  //       path: '/user-management',
  //       code: 'admin',
  //     },
  //     {
  //       name: t('common:Navigation_Drawer.Events'),
  //       path: '/events',
  //       code: 'events',
  //     },
  //     {
  //       name: t('common:Navigation_Drawer.DailyMessage'),
  //       path: '/daily-message',
  //       code: 'daily-message',
  //     },
  //   ],
  // },
  // ];

  const navTabs = [
    {
      icon: 'dash',
      name: t('common:Navigation_Drawer.Dash/Today'),
      path: '/',
      code: 'dashboard',
    },
    {
      icon: 'chat',
      name: t('common:Navigation_Drawer.Chat'),
      path: '/chat',
      code: 'chat',
    },
    {
      icon: 'live-class',
      name: t('common:Navigation_Drawer.Live Classes'),
      path: '/live',
      code: 'live_class',
    },
    {
      icon: 'book',
      name: t('common:Navigation_Drawer.Study'),
      code: 'study',
      subMenus: [
        {
          name: t('common:Navigation_Drawer.Study'),
          path: '/study',
          code: 'study',
        },
        // {
        //   name: t('common:Navigation_Drawer.Quiz'),
        //   path: '/quiz',
        //   code: 'study',
        // },
      ],
    },
    {
      icon: 'grades',
      name: t('common:Navigation_Drawer.Classbook'),
      code: 'grading',
      subMenus: [
        {
          name: t('common:Navigation_Drawer.Grades'),
          path: '/grades',
          code: 'grading',
        },
        {
          name: t('common:Navigation_Drawer.Attendance'),
          path: '/attendance',
          code: 'attendance',
        },
        // {
        //   name: t('common:Navigation_Drawer.Attendance'),
        //   path: '/attendance',
        //   code: 'grading',
        // },
      ],
    },
  ];

  return (
    <div className={`navigation-drawer-container ${isMinimized && 'minimized'}`} style={style}>
      <div className="navigation-drawer-content">
        <div className="mobile">
          <div className="mobile-content">
            <img className="logo" src={logoWhite} alt="logo" />
          </div>
          <div className="user-dropdown">
            <UserDropDown />
          </div>
        </div>
        <div
          className={`drawer-icon-container pointer ${isMinimized ? 'maximize' : 'minimize'}`}
          onClick={() => onLayoutChange(!isMinimized)}
        >
          <img src={minimizeIcon} alt="minimize-icon" />
        </div>
        <div className="logo-container">
          <div className="schoolify-logo">
            <img
              onClick={() => history.push('/')}
              className={`${isMinimized && 'hidden'} logo desktop`}
              src={logoWhite}
              alt="logo"
            />
            <img
              onClick={() => history.push('/')}
              className={`${!isMinimized && 'hidden'} logo desktop`}
              src={logoShort}
              alt="logo"
            />
          </div>
        </div>
        <div className="navigation-item-container">
          {user.role !== 'parent'
            ? navTabs.map(e => (
                <NavigationItem
                  subMenus={e.subMenus}
                  icon={e.icon}
                  name={e.name}
                  path={e.path}
                  key={e.name}
                  isOpen={isMinimized}
                  onLayoutChange={onLayoutChange}
                  hasAccess={user?.hasOwnProperty(e.code)}
                  permission={e.code}
                  selectedSubMenu={selectedSubMenu}
                  setSelectedSubMenu={setSelectedSubMenu}
                />
              ))
            : parentTabs.map(e => (
                <NavigationItem
                  icon={e.icon}
                  name={e.name}
                  path={e.path}
                  key={e.name}
                  isOpen={isMinimized}
                  onLayoutChange={onLayoutChange}
                  hasAccess={user?.hasOwnProperty(e.code)}
                  permission={e.code}
                  selectedSubMenu={selectedSubMenu}
                  setSelectedSubMenu={setSelectedSubMenu}
                />
              ))}

          {/* {user.role === 'teacher' &&
            teacherTabs.map(e => (
              <NavigationItem
                subMenus={e.subMenus}
                icon={e.icon}
                name={e.name}
                path={e.path}
                key={e.name}
                isOpen={isMinimized}
                onLayoutChange={onLayoutChange}
                hasAccess={user?.hasOwnProperty(e.code)}
                permission={e.code}
                selectedSubMenu={selectedSubMenu}
                setSelectedSubMenu={setSelectedSubMenu}
              />
            ))} */}
        </div>
      </div>
    </div>
  );
};

export default NavigationDrawer;
